import { motion } from "framer-motion";
import { Globe, TrendingUp, Cpu, Trophy, Clapperboard, Leaf, Users } from "lucide-react";

const AREAS = [
  { n: "01", slug: "world", name: "World", tag: "Geopolitics, global shifts & international affairs", img: "/assets/tile-1.jpg", Icon: Globe, span: "lg:col-span-7" },
  { n: "02", slug: "business", name: "Business", tag: "Markets, innovation economies & global finance", img: "/assets/tile-2.jpg", Icon: TrendingUp, span: "lg:col-span-5" },
  { n: "03", slug: "tech-ai", name: "Tech & AI", tag: "Frontier intelligence, robotics & digital futures", img: "/assets/tile-3.jpg", Icon: Cpu, span: "lg:col-span-4" },
  { n: "04", slug: "sport", name: "Sport", tag: "Human performance, athletic drama & global arenas", img: "/assets/tile-4.jpg", Icon: Trophy, span: "lg:col-span-4" },
  { n: "05", slug: "entertainment", name: "Entertainment", tag: "Cinema, culture, digital sound & performing arts", img: "/assets/tile-5.jpg", Icon: Clapperboard, span: "lg:col-span-4" },
  { n: "06", slug: "science-environment", name: "Science & Environment", tag: "Planetary resilience, climate science & space discovery", img: "/assets/tile-6.jpg", Icon: Leaf, span: "lg:col-span-6" },
  { n: "07", slug: "people-lifestyle", name: "People & Lifestyle", tag: "Human portraits, modern living & cultural stories", img: "/assets/tile-7.jpg", Icon: Users, span: "lg:col-span-6" },
];

export const Coverage = () => (
  <section id="coverage" data-testid="coverage-section" className="relative py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="mb-14 flex flex-col gap-6 md:flex-row md:items-end md:justify-between"
      >
        <div>
          <p className="font-mono text-[11px] tracking-[0.35em] text-cyan-400">EDITORIAL DESKS</p>
          <h2 className="mt-5 font-display text-3xl font-extrabold leading-tight tracking-tight sm:text-5xl">
            What we&rsquo;ll <span className="text-outline">cover.</span>
          </h2>
        </div>
        <p className="max-w-xs font-mono text-[11px] leading-relaxed tracking-[0.15em] text-slate-500">
          SEVEN DESKS. ONE PROMISE — REAL STORIES, TOLD OPENLY.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-12">
        {AREAS.map((a, i) => (
          <motion.div
            key={a.slug}
            data-testid={`coverage-card-${a.slug}`}
            initial={{ opacity: 0, y: 36 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.7, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
            className={`group relative h-60 overflow-hidden rounded-xl border border-white/10 bg-surface transition-colors duration-500 hover:border-cyan-400/40 sm:h-64 lg:h-72 ${a.span}`}
          >
            <img
              src={a.img}
              alt={`${a.name} coverage`}
              loading="lazy"
              className="absolute inset-0 h-full w-full object-cover opacity-60 transition-all duration-700 group-hover:scale-105 group-hover:opacity-85"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/30 to-transparent" />
            <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-cyan-400/0 to-transparent transition-all duration-500 group-hover:via-cyan-400/70" />
            <span className="absolute left-5 top-5 font-mono text-xs tracking-[0.3em] text-cyan-300/90">{a.n}</span>
            <div className="absolute bottom-5 left-5 right-5">
              <div className="flex items-center gap-3">
                <span className="rounded-lg border border-cyan-400/30 bg-ink/60 p-2 text-cyan-300 backdrop-blur">
                  <a.Icon className="h-4 w-4" />
                </span>
                <h3 className="font-display text-lg font-extrabold tracking-tight sm:text-xl">{a.name}</h3>
              </div>
              <p className="mt-2 text-xs leading-relaxed text-slate-300 transition-all duration-500 sm:max-h-0 sm:opacity-0 sm:group-hover:max-h-12 sm:group-hover:opacity-100">
                {a.tag}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
